import {useMemo} from 'react';
import {useBasket} from 'brandHooks';
import PaymentMethodsFactory from 'coreClasses/payments/PaymentMethodsFactory';
import type PaymentMethod from 'coreClasses/payments/paymentMethods/PaymentMethod';
import type {PaymentMethod as TPaymentMethod} from '../../store/data/basket/types';

/**
 * Returns payment method instance if exist
 * @param {string} paymentMethodID - payment method ID
 * @returns {PaymentMethod|null} - payment method or null
 */
const usePaymentMethod = (paymentMethodID: string): PaymentMethod | null => {
	const basket = useBasket();
	const paymentMethodObjects = basket?.applicablePaymentMethods || [];
	const paymentMethod = useMemo(() => {
		const paymentMethodObject = paymentMethodObjects.find((paymentMethodObjects: TPaymentMethod) => {
			return paymentMethodObjects.id === paymentMethodID;
		});

		return paymentMethodObject ? PaymentMethodsFactory.create(paymentMethodObject.id, paymentMethodObject) : null;
	}, [paymentMethodObjects]);

	return paymentMethod;
};

export default usePaymentMethod;
